import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { removeRegionFromPath } from 'lib/url/searchUrlUtils'

export interface SignupSuccessPage {
  type: comluxgroup.Page_1_0_2['type']
  category: comluxgroup.Page_1_0_2['category']
  url?: string
  startsWith?: string
  endsWith?: string
}
export const pages: Array<SignupSuccessPage> = [
  {
    url: '/', // This URL
    type: 'home', // Should be categorized as this type
    category: null, // and this category
  },
  {
    url: '/hotels',
    type: 'vertical',
    category: 'hotel',
  },
  {
    url: '/rentals',
    type: 'vertical',
    category: 'rental',
  },
  {
    url: '/tours',
    type: 'vertical',
    category: 'tour',
  },
  {
    url: '/cruises',
    type: 'vertical',
    category: 'cruise',
  },
  {
    url: '/car-hire',
    type: 'vertical',
    category: 'car_hire',
  },
  {
    url: '/ultra-lux',
    type: 'vertical',
    category: 'ultralux',
  },
  {
    url: '/experiences',
    type: 'vertical',
    category: 'experience',
  },
  {
    url: '/flights',
    type: 'vertical',
    category: 'flight',
  },
  {
    startsWith: '/flights/campaigns',
    type: 'vertical',
    category: 'flight',
  },
  {
    startsWith: '/flight/deal',
    type: 'vertical',
    category: 'flight',
  },
  {
    url: '/shop',
    type: 'vertical',
    category: 'shop',
  },
  {
    url: '/trip-planner',
    startsWith: '/trip-planner',
    type: null,
    category: 'trip_planner',
  },
  {
    url: '/gift-cards',
    type: null,
    category: 'gift_card',
  },
  {
    url: '/travel-protection',
    type: null,
    category: 'travel_protection',
  },
  {
    url: '/support',
    type: null,
    category: 'support',
  },
  {
    startsWith: '/shop/category',
    type: 'vertical',
    category: 'shop',
  },
  {
    startsWith: '/shop/brand',
    type: 'vertical',
    category: 'shop',
  },
  {
    startsWith: '/refer',
    type: null,
    category: 'refer',
  },
  {
    startsWith: '/search/tours',
    type: 'search',
    category: 'tour',
  },
  {
    startsWith: '/search/cruises',
    type: 'search',
    category: 'cruise',
  },
  {
    startsWith: '/search/car-hire',
    type: 'search',
    category: 'car_hire',
  },
  {
    startsWith: '/search/experiences',
    type: 'search',
    category: 'experience',
  },
  {
    startsWith: '/flights-search-results',
    type: 'search',
    category: 'flight',
  },
  {
    startsWith: '/search/map',
    type: 'search_map',
    category: 'hotel',
  },
  {
    startsWith: '/search/shop',
    type: 'search',
    category: 'shop',
  },
  {
    startsWith: '/search',
    type: 'search',
    category: 'hotel',
  },
  {
    startsWith: '/metasearch',
    type: 'marketing',
    category: 'hotel',
  },
  {
    startsWith: '/account/my-escapes/order',
    type: 'account',
    category: 'order',
  },
  {
    startsWith: '/account',
    type: 'account',
    category: null,
  },
  {
    startsWith: '/tv',
    type: null,
    category: 'tv',
  },
  {
    endsWith: '.p1',
    type: 'marketing',
    category: null,
  },
  {
    endsWith: '.d1',
    type: 'marketing',
    category: null,
  },
  {
    endsWith: '.h1',
    type: 'marketing',
    category: null,
  },
  {
    startsWith: '/destination',
    type: 'marketing',
    category: 'destination',
  },
  {
    startsWith: '/campaign',
    type: 'marketing',
    category: 'campaign',
  },
  {
    endsWith: '/purchase',
    type: 'checkout',
    category: null,
  },
  {
    startsWith: '/booking',
    type: 'inflow',
    category: null,
  },
  {
    startsWith: '/checkout',
    type: 'inflow',
    category: null,
  },
  {
    startsWith: '/cart',
    type: 'inflow',
    category: 'cart',
  },
]

export function getPageCategoryAndType(pathname: string): SignupSuccessPage {
  const pathWithoutRegion = removeRegionFromPath(pathname)
  const matchingPage = pages.find((page) => {
    if (page.endsWith) return pathWithoutRegion.endsWith(page.endsWith)
    if (page.startsWith) return pathWithoutRegion.startsWith(page.startsWith)
    if (page.url) return pathWithoutRegion === page.url
  })
  if (matchingPage) return matchingPage

  return { type: null, category: null, url: pathname }
}
